var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RelatedInfo',{attrs:{"error":_vm.error,"title":_vm.title,"type":'mentioned-in'}},[[_c('ul',_vm._l((_vm.mentions),function(mention,index){return _c('li',{key:((mention.slug) + "-" + index)},[_c('a',{attrs:{"href":((_vm.root.WWW) + "/" + (mention.slug))}},[_vm._v(_vm._s(mention.title))])])}),0)]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66987084","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MentionedIn/MentionedIn.vue
// module id = null
// module chunks = 